// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsent_root__25R9b"};